import { render, staticRenderFns } from "./SQuesFive.vue?vue&type=template&id=69dc7e26&"
import script from "./SQuesFive.vue?vue&type=script&lang=js&"
export * from "./SQuesFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports